module.exports = __webpack_public_path__ + "static/media/Abbey_Woods_Condos.4ab916b0.pdf";